import { useAuthSelector } from '@providers/AuthProvider/ui/AuthProvider';
import { FC, PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface ISuperAdminProtectedRouteProps extends PropsWithChildren {}

/**
 * @description Custom component that protects routes for super admin only.
 * Redirects non-super-admin users to home page.
 * Can be used as a route element (with Outlet) or as a wrapper component.
 */
const SuperAdminProtectedRoute: FC<ISuperAdminProtectedRouteProps> = (
  props
) => {
  const { children } = props;

  const userData = useAuthSelector((state) => state.userData);
  const loading = useAuthSelector((state) => state.loading);

  // Show nothing while loading to avoid flash of content
  if (loading) {
    return null;
  }

  // Redirect non-super-admin users
  if (!userData?.is_superuser) {
    return <Navigate to="/home" replace />;
  }

  // If used as a route element (with children routes), render Outlet
  // Otherwise, render children directly
  return children ? <>{children}</> : <Outlet />;
};

export { SuperAdminProtectedRoute };
